import React from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../Atoms';

/**
 * Banner (EventDetail)
 * -------------------------------------------------------
 * Hero for a single event's detail page — pulled out into its
 * own file/folder the same way AcDevKitSkill/Banner/index.js is
 * separated from the rest of that page, with its own style.css
 * for the decorative corner accent (class renamed to
 * `.event-banner` so it doesn't collide with the existing
 * global `.banner` class from AcDevKitSkill/Banner/style.css).
 *
 * Takes the resolved `event` object as a prop rather than
 * looking it up itself, so it stays a plain presentational
 * component — EventDetail/index.jsx does the slug lookup.
 */

const CalendarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="rgb(35, 180, 85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

const PinIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="rgb(35, 180, 85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 1 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const TicketIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="rgb(35, 180, 85)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7h18v10H3z" />
    <path d="M3 12h18" strokeDasharray="2 2" />
  </svg>
);

const DownloadIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v12m0 0l-4-4m4 4l4-4" />
    <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
  </svg>
);

const BoothIcon = ({ className }) => (
  <svg     className="w-4 h-4 shrink-0"    viewBox="0 0 24 24"    fill="none"    stroke="rgb(35, 180, 85)"    strokeWidth="2"    strokeLinecap="round"    strokeLinejoin="round"
    aria-hidden="true"  >
    <path d="M3 9h18l-2-5H5L3 9Z" />
    <path d="M3 9v11h18V9" />
    <path d="M8 20V9M16 20V9" />
    <path d="M10 13h4v7h-4z" />
  </svg>
);


export default function Banner({ event }) {
  const navigate = useNavigate();
  const {
    name,
    date,
    location,
    venue,
    tag,
    boothNumber,
    image,
    brochure,
    isPast,
    listingBanner,
    boldText
  } = event;
const parts = name.split(boldText);
  return (
    <section className="event-banner flex bg-light-gradient pb-10 md:pb-16 pt-24 md:pt-28 lg:pt-32">
      <div className="z-10 containers-min mx-auto sm:flex md:flex-row flex-col sm:items-center">
        <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px]">
          {/* <div className="flex items-center gap-3 mb-4">
            <div className="w-1 h-5 bg-[rgb(35,180,85)] rounded-full" />
            <span className="text-[rgb(35,180,85)] font-poppins font-semibold text-xs tracking-[1.5px] uppercase">
              {tag}{isPast ? ' \u00b7 Past Event' : ''}
              {tag}
            </span>
          </div> */}

         

          <h1 className="leading-tight !h3 font-gilroylight font-light">
            {parts[0]}
            <span className="font-gilroybold">{boldText}</span>
            {parts[1]}
          </h1>

          <div className="mt-5 space-y-2 font-poppins text-black/80 md:text-2xl">
            <div className="flex items-center gap-2">
              <CalendarIcon className="w-4 h-4 shrink-0" />
              <span>{date}</span>
            </div>
            <div className="flex items-center gap-2">
              <PinIcon className="w-4 h-4 shrink-0" />
              <span>{venue || location}</span>
            </div>
            {tag === 'Exhibitor' && boothNumber && (
              <div className="flex items-center gap-2">
                <BoothIcon className="w-4 h-4 shrink-0" />
                <span>Booth {boothNumber}</span>
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-4 mt-6">
            {/* <Button
              title={isPast ? 'Get in Touch' : 'Meet Us There'}
              onClick={() => navigate('/get-in-touch')}
            /> */}
            {/* {brochure && (
              <a
                href={brochure}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 font-poppins font-semibold text-sm border border-[rgb(35,180,85)] text-[rgb(35,180,85)] rounded-md px-5 py-3 hover:bg-[rgb(35,180,85)] hover:text-white transition-colors"
              >
                <DownloadIcon className="w-4 h-4" />
                Download Brochure
              </a>
            )} */}
          </div>
        </div>

        <div className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative">
          <img
            src={listingBanner}
            alt={name}
            className="w-full h-auto rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.1)] object-cover"
          />
        </div>
      </div>
    </section>
  );
}
